import Clickable from 'atoms/Clickable/Clickable';
import styled from 'styled-components';
import { cssVar } from 'styles/helper';

export const OverlayBackground = styled(Clickable)`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 110;
  opacity: 0.7;
  height: 100vh;
  width: 100vw;
  position: fixed;
  background: ${cssVar('bg-overlay')};
`;
